module.exports = __webpack_public_path__ + "static/team-alert-846b9dca48cb47e17a33aea3438de5a8.png";